import * as React from "react"

// Footer Components
import SubmitReport from "./submitReport"
import UpperFooter from "../footer/upperFooter"
import MiddleFooter from "../footer/middleFooter"
import LowerFooter from "../footer/lowerFooter"
import ClickyTracker from "../components/clickyTracker"

// Internal JavaSript libraries
import { getCountry } from "../js/getCountry"

class Footer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      // Import the routes for the country
      routes: require("../data/routes.json"),
      country: getCountry(this.props.countryCode)
    }
  }

  render() {
    return (
      <footer className="pt-5">
        <ClickyTracker />
        <SubmitReport />
        <UpperFooter country={this.state.country} routes={this.state.routes} />
        <MiddleFooter
          countryCode={this.state.country.countryCode}
          routes={this.state.routes}
        />
        <LowerFooter country={this.state.country} routes={this.state.routes} />
      </footer>
    )
  }
}

export default Footer
